const SELLING_PLAN_KEY = 'selling_plan';
const SELLING_PLAN_INPUT_KEY = `[name="${SELLING_PLAN_KEY}"]`;
const PAYLOAD_KEY_NAME = SELLING_PLAN_KEY;

export function interceptAddToCartRequestAndAddSellingPlan(sellingPlanId) {
  jQuery(document).on('cart.requestStarted', function() {
    jQuery.ajaxSetup({
      beforeSend: function (_, settings) {
        if (settings.url === '/cart/add.js') {
          settings.data += '&' + jQuery.param({ // assuming "id" param always ==> append data
            [PAYLOAD_KEY_NAME]: sellingPlanId,
          });
        }

        return true;
      }
    });
  });
}

export function init(productForm) {
  const sellingPlanInput = productForm.querySelector(SELLING_PLAN_INPUT_KEY)

  if (!sellingPlanInput) {
    console.warn('Bold SubscriptionWidget init() selling plan not found. productForm: ', productForm);
  }

  if (sellingPlanInput?.value) { // does this product have a selling plan (value)?
    interceptAddToCartRequestAndAddSellingPlan(sellingPlanInput.value)
    // ...
    // more init functions
    // ...
  } else {
    interceptAddToCartRequestAndAddSellingPlan('') // at the least, add in no plan
  }
}